import * as signalR from "@microsoft/signalr";

class SignalRService {
  constructor() {
    this.connection = null;
    this.isConnected = false;
    this.listeners = new Map();
    this.currentUserId = null;
  }

  async startConnection(userId) {
    if (!userId) return;

    // 1. If already connected to this user, stay connected
    if (this.connection && this.isConnected && this.currentUserId === userId) {
      return;
    }

    // 2. If the user changed, stop the old one completely
    if (this.connection) {
      await this.stopConnection();
      this.connection = null; // Explicitly clear the object
    }

    const apiUrl = process.env.REACT_APP_API_BASE_URL;
    const hubUrl = `${apiUrl}/hubs/notification?userId=${encodeURIComponent(userId)}`;

    this.connection = new signalR.HubConnectionBuilder()
        .withUrl(hubUrl)
        .withAutomaticReconnect()
        .configureLogging(signalR.LogLevel.Information)
        .build();

    try {
      await this.connection.start();
      this.isConnected = true;
      this.currentUserId = userId;

      // Listeners setup...
    } catch (error) {
      // Check if the error is just an Abort (user navigated away or double-click)
      if (error.name !== "AbortError") {
        console.error("SignalR Connection Error:", error);
      }
      this.isConnected = false;
      this.currentUserId = null;
    }
  }

  async stopConnection() {
    if (this.connection) {
      try {
        await this.connection.stop();
        this.isConnected = false;
        this.currentUserId = null;
      } catch (error) {
        console.error("Error stopping SignalR connection:", error);
      }
    }
  }

  addListener(event, callback) {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, []);
    }
    this.listeners.get(event).push(callback);
  }

  removeListener(event, callback) {
    if (this.listeners.has(event)) {
      const callbacks = this.listeners
        .get(event)
        .filter((cb) => cb !== callback);
      this.listeners.set(event, callbacks);
    }
  }

  notifyListeners(event, data) {
    if (this.listeners.has(event)) {
      this.listeners.get(event).forEach((callback) => callback(data));
    }
  }
}

export default new SignalRService();
